import Model from "./Model";

export default class extends Model {
    constructor(urls) {
        super(urls);
        this.urls.allow_right = urls.route_allow_right;
        this.urls.disable_right = urls.route_disable_right;
        this.urls.allow_action = urls.route_allow_action;
        this.urls.disable_action = urls.route_disable_action;
    }

    async loadTable() {
        let response = await super.list().then(result => {return result});
        let result = {
            tbody: []
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(client => {
                let telem = {
                    tbody: {}
                };
                telem.id = client.id;
                telem.tbody.name = client.name;
                result.tbody.push(telem);
            });
        }
        return result;
    }

    async allowRight(service_id) {
        if(this.urls.allow_right === undefined)
        {
            console.log('error: route_allow_right');
            return false;
        }
        return await axios.post(this.urls.allow_right, {
            service_id: service_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async disableRight(service_id) {
        if(this.urls.allow_right === undefined)
        {
            console.log('error: route_disable_right');
            return false;
        }
        return await axios.post(this.urls.disable_right, {
            service_id: service_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async allowAction(service_id, action) {
        if(this.urls.allow_action === undefined)
        {
            console.log('error: route_allow_action');
            return false;
        }
        return await axios.post(this.urls.allow_action, {
            service_id: service_id,
            action: action
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async disableAction(service_id, action) {
        if(this.urls.disable_action === undefined)
        {
            console.log('error: route_disable_action');
            return false;
        }
        return await axios.post(this.urls.disable_action, {
            service_id: service_id,
            action: action
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }
}
